import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { getRsSavedLocation } from '@Pages/RetroSynthesis/RetroSynthesisRoot/utils/rsSavedLocation';

function RsRootInitializer({ projectsCount }) {
  const rsSavedLocation = getRsSavedLocation();

  if (rsSavedLocation) {
    // If last visited saved location - redirect to it
    return <Redirect to={rsSavedLocation} />;
  }
  if (projectsCount === 0) {
    // If projects count is 0 - redirect to draw page
    return <Redirect to={RsRoute.DRAW_STRUCTURE} />;
  }
  // By default - go to projects list to reduce user waiting time
  return <Redirect to={RsRoute.PROJECTS_LIST} />;
}

RsRootInitializer.defaultProps = {};

RsRootInitializer.propTypes = {
  projectsCount: PropTypes.number,
};

export default RsRootInitializer;
